{
  "coreCommon": {
    "profileImage": "profileImage",
    "pageInfo": "pageInfo",
    "imprint": "imprint"
  }
}
